// src/services/stripeService.ts
import { loadStripe } from "@stripe/stripe-js";
import { supabase } from "../supabaseClient";

// ✅ Uses your public key from .env (safe to expose)
const STRIPE_PK = String(process.env.REACT_APP_STRIPE_PUBLIC_KEY || "");
const stripePromise = loadStripe(STRIPE_PK);

export const initializeCheckout = async (priceId: string) => {
  // ^ kept signature unchanged on purpose (drop-in). priceId is now ignored.
  try {
    if (!STRIPE_PK) throw new Error("Missing REACT_APP_STRIPE_PUBLIC_KEY");
    const stripe = await stripePromise;
    if (!stripe) throw new Error("Stripe failed to initialize");

    // ✅ Get logged-in user from Supabase
    const {
      data: { user },
      error: userError,
    } = await supabase.auth.getUser();

    if (userError || !user) {
      alert("You must be logged in to start checkout.");
      return;
    }

    const auth_id = String(user.id);
    console.log("🔹 Starting checkout for user:", auth_id);

    // ✅ Send request to backend (no priceId; server uses .env for both prices)
    const response = await fetch("https://askrexi.comverex.ai/create-checkout-session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ auth_id }),
      credentials: "omit",
    });

    console.log("🔹 Response status:", response.status);

    const text = await response.text();
    console.log("🔹 Raw response:", text);

    if (!response.ok) {
      throw new Error(`Checkout session failed: ${response.status} ${text}`);
    }

    // ✅ Parse the JSON safely
    let sessionData: any;
    try {
      sessionData = JSON.parse(text);
    } catch {
      throw new Error("Failed to parse JSON: " + text);
    }

    console.log("✅ Stripe session created:", sessionData);

    const sessionId = String(sessionData.id || sessionData.sessionId || "");
    if (!sessionId) throw new Error("Missing session ID in response");

    const { error } = await stripe.redirectToCheckout({ sessionId });
    if (error) throw new Error(error.message);
  } catch (error) {
    console.error("❌ Error in payment flow:", error);
    alert("There was a problem starting checkout. Please try again.");
  }
};

// optional placeholder for future expansions
export const createSubscription = async (customerId: string, priceId: string) => {
  console.warn("createSubscription() not implemented yet.");
};
